import { PhaseEvent, PhaseEventHandler, PhaseEventName } from '../types';

export class PhaseEventBus<TPayload = unknown> {
  private listeners: Record<PhaseEventName, Set<PhaseEventHandler<TPayload>>>;

  constructor() {
    this.listeners = {
      load: new Set(),
      save: new Set(),
      'data:update': new Set(),
      activate: new Set(),
      deactivate: new Set(),
      status: new Set(),
    };
  }

  subscribe(eventName: PhaseEventName, handler: PhaseEventHandler<TPayload>): () => void {
    this.listeners[eventName].add(handler);

    return () => {
      this.listeners[eventName].delete(handler);
    };
  }

  emit(eventName: PhaseEventName, payload?: TPayload): void {
    const event: PhaseEvent<TPayload> = { name: eventName, payload };

    this.listeners[eventName].forEach(handler => handler(event));
  }
}
